import React, {useEffect, useState} from 'react';
import apiRequests from "../../../Component/axios/config/config";
import Loading from "../../../Component/Loading/Loading";
import {Link} from "react-router-dom";
import noImage from "../../../font & image/image/noImages.png";
import toast from "react-hot-toast";
import NavBar from "../../../Component/NavBar/NavBar";
import {IoIosAddCircleOutline} from "react-icons/io";
import {useNavigate} from "react-router-dom";
import {FaTrash} from "react-icons/fa";


export default function SpecialOffers() {


    const [products, setProducts] = useState([]);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");

    const [loading, setLoading] = useState(true);
    const [loadingAddOffer, setLoadingAddOffer] = useState({status: false, id: null});

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchProducts(currentPage);
    }, [currentPage, searchQuery]);

    const fetchProducts = (page) => {

        setLoading(true);
        const params = {
            page,
            limit: 10,
        };

        if (searchQuery) {
            params.search = searchQuery;
        }

        apiRequests.get(`/api/offers/v1/get-all`, {params})
            .then((response) => {
                setProducts(response.data.data.docs);
                setTotalPages(response.data.data.totalPages);
            })
            .catch((err) => {
                if (err.status === 401 || err.status === 403) {
                    navigate("/login");
                }
                console.error("Failed to fetch products");
            })
            .finally(() => setLoading(false));
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleRemoveFromSpecialOffer = (productId) => {
        setLoadingAddOffer({...loadingAddOffer, status: true, id: productId});
        apiRequests.delete(`/api/offers/v1/delete/${productId}`)
            .then(() => {
                toast.success("Product removed from special offers!");
                fetchProducts(0);
            })
            .catch((error) => {
                console.error("Failed to removed product to special offers", error);
                toast.error("Failed to removed product to special offers");
            }).finally(() => setLoadingAddOffer({...loadingAddOffer, status: false}));
    };


    return (
        <div className="p-6">

            <div className="text-3xl font-bold text-gray-800 mb-6">
                Special offers
            </div>

            <NavBar
                item={[
                    {
                        icon: <IoIosAddCircleOutline/>,
                        title: "Add To Offers",
                        onClick: () => navigate("add"),
                    },
                ]}
                onSearch={(value) => {
                    setSearchQuery(value);
                    setCurrentPage(1);
                }}
            />

            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead className="bg-gradient-to-r from-green-400 to-blue-500 text-white">
                        <tr>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Image</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Name</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Price</th>
                            <th className="px-6 py-3 text-center text-sm font-medium text-nowrap">Start Time</th>
                            <th className="px-6 py-3 text-center text-sm font-medium text-nowrap">End Time</th>
                            <th className="px-6 py-3 text-center text-sm font-medium text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center">
                                    <Loading/>
                                </td>
                            </tr>
                        ) : products.length > 0 ? (
                            products.map((product) => {
                                    return (
                                        <tr key={product.product._id} className="hover:bg-gray-100 transition duration-200">
                                            <td className="px-6 py-4 text-nowrap">
                                                <img
                                                    src={product.product.images ? `https://api.goalafarin.com/${product.product.images[0]?.path}` : noImage}
                                                    alt={product.product.name}
                                                    className="w-16 h-16 object-cover rounded-lg"
                                                />
                                            </td>
                                            <td className="px-6 py-4 text-gray-800 font-medium text-nowrap"><Link
                                                to={`/product/${product.product._id}`}> {product.product.name}</Link></td>
                                            <td className="px-6 py-4 text-gray-800 font-semibold text-nowrap">
                                                {product.discount !== 0 ? (
                                                    <div className="flex flex-col gap-1">
                                                        <div className="flex">
                                                            <del className="text-red-600 px-1">
                                                                {product.product.price}
                                                            </del>
                                                            <div
                                                                className="w-fit rounded-full p-1 bg-red-600 text-white text-[10px]">
                                                                {product.discount} %
                                                            </div>
                                                        </div>

                                                        <p className="px-1">
                                                            {product.finalPrice_per_discount} €
                                                        </p>

                                                    </div>
                                                ) : (
                                                    <p className="px-1">
                                                        {product.finalPrice_per_discount} €
                                                    </p>
                                                )}

                                            </td>
                                            <td>
                                                {product?.startTime
                                                    ? new Date(product.startTime).toLocaleString()
                                                    : "-"
                                                }
                                            </td>

                                            <td>
                                                {product?.expiredtime
                                                    ? new Date(product.expiredtime).toLocaleString()
                                                    : "-"
                                                }
                                            </td>
                                            <td className="px-6 py-4 text-center space-x-4 text-nowrap">
                                                {loadingAddOffer.id === product.product._id ? (
                                                    <Loading/>
                                                ) : (
                                                    <button
                                                        className="text-red-600 hover:text-red-800 font-medium"
                                                        onClick={() => handleRemoveFromSpecialOffer(product._id)}
                                                        disabled={loadingAddOffer.status}
                                                    >
                                                        <p className="md:hidden">Remove From Special Offers</p>
                                                        <FaTrash className="md:flex hidden" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    )
                                }
                            )
                        ) : (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                                    No products found
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>

                    <div className="flex justify-center items-center mt-6 space-x-2">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === 1
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Prev
                        </button>

                        <span className="px-4">
                            Page {currentPage} of {totalPages}
                        </span>

                        <button
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(currentPage + 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === totalPages
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Next
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}